import React from 'react';
import styled from '@emotion/styled/macro';
import vars from '@variables';
import { H4Atom } from '@atoms/text-atoms/text-atoms';
import { TableRowProps } from './horizontal-table.types';

const TableRow: React.FC<TableRowProps> = ({
  label,
  children,
  isFullWidth,
  className,
}) => {
  if (label && children) {
    return (
      <div className={className} data-testid="styled-table-row">
        <H4Atom className="label">{label}</H4Atom>
        <div className="value">{children}</div>
      </div>
    );
  } else {
    return null;
  }
};

const StyledTableRow = styled(TableRow)`
  ${({ isFullWidth }) =>
    isFullWidth
      ? '--col-1-width: 100%;--col-2-width: 100%;'
      : '--col-1-width: 30%;--col-2-width: 70%;'}
  &:first-of-type {
    border-top: 1px dashed ${vars.transparentCoreGrey};
  }
  border-bottom: 1px dashed ${vars.transparentCoreGrey};
  padding: 0 0.5rem 0 0;
  .label,
  .value {
    ${vars.fontSize4}
    display: inline-block;
    min-height: 3rem;
    text-align: left;
    vertical-align: top;
  }
  .label {
    width: var(--col-1-width);
    margin-top: ${vars.spacingS};
    padding-top: ${vars.spacingS};
    padding-right: ${vars.spacingM};
    font-weight: ${vars.fontWeightRegular};
    color: ${vars.plasticsBlue};
  }
  .value {
    width: var(--col-2-width);
    margin: ${vars.spacingS} 0;
    ${vars.fontSize4}
    line-height: 1.4;
    letter-spacing: 0.0015em;
    &:last-of-type {
      padding-bottom: 0;
    }
  }
  ${H4Atom} {
    margin: 0;
    font-weight: ${vars.fontWeightMedium};
  }
`;

export default StyledTableRow;
